// Ngữ cảnh người chơi dùng chung cho Lịch Luyện, so sánh đồ, tooltip: P, Tam Nguyên, trang bị.
import { giai, powerIndex } from '@data/powerScale';
import { baseDef } from '@data/items/bases';
import { EQUIP_SLOTS, type SlotKind } from '@data/items/types';
import { stepInfo, type CultivationState } from '../cultivation';
import { combatStats, slotKindOf, type Loadout, type PlayerBase, type UtilityBlock } from '../items/stats';
import type { Equipped } from '../items/bag';
import { dominantTri } from '../items/generate';
import type { TrialCtx } from '../trial';

export function playerBase(cult: CultivationState): PlayerBase {
  const i = stepInfo(cult.step);
  return { step: cult.step, power: powerIndex(i.realm, i.s), tri: cult.technique.triOrigin };
}

/** Giai người chơi (realm × 10 + tiểu cảnh). */
export function playerGiai(cult: CultivationState): number {
  const i = stepInfo(cult.step);
  return giai(i.realm, i.s);
}

/** Ô trống được ưu tiên ×1,5 khi rơi đồ (ITEMS §7.5, bản P0: ô chưa có món). */
export function focusSlots(equipped: Equipped): SlotKind[] {
  return [...new Set(EQUIP_SLOTS.filter((s) => !equipped[s]).map(slotKindOf))];
}

export function trialCtxFor(cult: CultivationState, equipped: Equipped, eff: number): TrialCtx {
  const c = combatStats(playerBase(cult), equipped as Loadout);
  const w = equipped.weapon;
  return {
    playerL: cult.step + 1,
    realmIdx: stepInfo(cult.step).realmIdx,
    atk: c.atk,
    utility: c.utility,
    eff,
    weaponPref: w ? baseDef(w.base).weaponType : undefined,
    favorTri: w ? dominantTri(baseDef(w.base).scaling) : undefined,
    focusSlots: focusSlots(equipped),
  };
}

/** Phần trang bị cộng vào tu luyện (Hấp Linh %, Bế Quan Hiệu Suất). */
export function gearCultBonus(u: UtilityBlock): CultivationState['gear'] {
  return { qiRatePct: u.qiRate, offlineEffPct: u.offlineEff };
}
